import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { useMemo } from 'react';
import {
  ConfigurationGroupBasicModel,
  useListConfigurationGroupsQuery,
} from '@casops/store/apis/configurationGroupsApi';
import { useParams } from 'react-router-dom';
import { AssetDeviceType, useGetAssetQuery } from '@casops/store/apis/registeredAssetsApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { ConfigurationGroupDeviceType } from '@casops/store/apis/commonModels';

// Mapping from AssetDeviceType to ConfigurationGroupDeviceType
const mapAssetToConfigurationGroupDeviceType: Record<
  AssetDeviceType,
  ConfigurationGroupDeviceType
> = {
  [AssetDeviceType.X1]: ConfigurationGroupDeviceType.X1,
  [AssetDeviceType.X9]: ConfigurationGroupDeviceType.X9,
  [AssetDeviceType.IVU]: ConfigurationGroupDeviceType.IVU,
  [AssetDeviceType.IVUPlus]: ConfigurationGroupDeviceType.IVUPlus,
  [AssetDeviceType.IVUPlusGen2]: ConfigurationGroupDeviceType.IVUPlus,
  // Non-matching types default to Generic
  [AssetDeviceType.Unknown]: ConfigurationGroupDeviceType.Generic,
  [AssetDeviceType.PPU]: ConfigurationGroupDeviceType.Generic,
};

const getCompatibleConfigurationDeviceType = (assetDeviceType: AssetDeviceType | undefined) => {
  const compatibleDeviceType = [ConfigurationGroupDeviceType.Generic];

  if (!assetDeviceType) return compatibleDeviceType;

  compatibleDeviceType.push(mapAssetToConfigurationGroupDeviceType[assetDeviceType]);
  return compatibleDeviceType;
};

export const useConfigGroupNumberOptions = (): DropdownItemProps<number>[] => {
  const { assetId } = useParams();
  const { data: configGroups } = useListConfigurationGroupsQuery(undefined, {
    refetchOnMountOrArgChange: 60,
  });

  const queryParams = assetId ? { id: Number(assetId) } : skipToken;

  const { data: assetData } = useGetAssetQuery(queryParams, {
    refetchOnMountOrArgChange: 60,
  });
  const assetDeviceType = assetData?.hw;
  const compatibleConfigurationDeviceType = getCompatibleConfigurationDeviceType(assetDeviceType);

  //Now we need list only the configGroups?.hw that match assetDeviceType

  return useMemo(() => {
    if (!configGroups) return [];

    const filteredConfigGroups = configGroups.filter(group =>
      compatibleConfigurationDeviceType.includes(group.hw),
    );
    return filteredConfigGroups.map(({ id, name }: ConfigurationGroupBasicModel) => {
      return { key: id.toString(), value: id, stringValue: name, label: name };
    });
  }, [compatibleConfigurationDeviceType, configGroups]);
};
